export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6952.c87d73d1.jpg";